/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { selectedServicesNew } from "../../Slice/serviceSlice";
import { useDispatch, useSelector } from "react-redux";
import { axiosInstance } from "../../utils/axiosInstance";

const Header = () => {
  const router = useLocation();
  const dispatch = useDispatch();
  const { Provider } = useSelector((state) => state.auth);

  const [scrollClass, setScrollClass] = useState("");

  const [categories, setCategories] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const accessToken = localStorage.getItem("accessToken");
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("accessToken", accessToken);
    localStorage.removeItem("user", JSON.stringify(user));
    navigate("/login");
  };

  useEffect(() => {
    const Category = async () => {
      try {
        const response = await axios.get(
          "https://studioapi.dev-sh.xyz/api/provider-category"
        );
        setCategories(response?.data?.data);
      } catch (err) {}
    };
    Category();
  }, []);

  const [searchService, setSearchService] = useState([]);
  const [serviceName, setServiceName] = useState("");

  const handleServiceClick = (service) => {
    try {
      const { provider_category_detail } = service;
      localStorage.setItem('category',service?.provider_category_detail?.provider_category?.name)
      dispatch(selectedServicesNew(service)); // Redux action call
      navigate(`/services/${service?.provider_category_detail?.provider?.id}`, {
        state: service,
      });
      dispatch(
        selectedServicesNew({
          ...Provider,
          provider_category_detail: service?.provider_category_detail?.provider,
        })
      );
    } catch (error) {
      console.error("Error handling service selection", error);
    }
  };

  const fetchSuggestions = async (name) => {
    if (!name) {
      setSearchService([]);
      return;
    }
    try {
      const response = await axiosInstance.get(`search-service/${name}`);
      if (response?.data?.data?.length > 0) {
        setSearchService(response.data.data);
      } else {
        setSearchService([]);
      }
    } catch (error) {
      console.error("Error fetching suggestions", error);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollY / windowHeight) * 100;

      if (scrollPercent >= 10) {
        setScrollClass("active");
      } else if (scrollPercent >= 5) {
        setScrollClass("hide");
      } else {
        setScrollClass("");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="main-header main-menu">
      <div
        className={`header-sticky ${scrollClass}`}
        style={
          router.pathname.includes("/providers") ||
          router.pathname.includes("/otherservice")
            ? { backgroundColor: "#524b4b" }
            : {}
        }
      >
        <nav className="navbar navbar-expand-lg navbar-light py-lg-4 py-3">
          <div className="container">
            {/* Logo Start */}
            <Link className="navbar-brand" to="/">
              <img
                style={{ width: "150px" }}
                src="/assests/images/STUDDIO.png"
                alt="Logo"
              />
            </Link>
            {/* Logo End */}

            {/* Navbar Toggler Button for Mobile */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Main Menu Start */}
            <div
              className="collapse navbar-collapse d-lg-flex  justify-content-lg-end"
              id="navbarNav"
            >
              {/* Search Bar */}
              <div className="d-flex flex-lg-row flex-column justify-content-center justify-content-lg-end">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0 justify-content-center gap-2 gap-lg-0">
                  <li className="nav-item">
                    <Link className="nav-link" to="/">
                      Home
                    </Link>
                  </li>

                  {/* Services Dropdown */}
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="servicesDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Services
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="servicesDropdown"
                    >
                      {categories.map((c, idx) => (
                        <li key={idx}>
                          <Link
                            className="dropdown-item"
                            to={`/providers/${c.id}?cat=${c.name}`}
                            style={{ borderRadius: "12px" }}
                          >
                            {c.name}
                          </Link>
                        </li>
                      ))}
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/providers"
                          style={{ borderRadius: "12px" }}
                        >
                          All Providers
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Provider Login */}
                  <li className="nav-item highlighted-menu">
                    <a className="nav-link" href="https://saloon.dev-um.xyz">
                      Provider Login
                    </a>
                  </li>

                  {/* Logout/Login */}
                  <li className="nav-item highlighted-menu">
                    <a className="nav-link" onClick={logout}>
                      {accessToken ? "Log out" : "Login"}
                    </a>
                  </li>
                </ul>
                <div className="bg-light rounded-pill px-3 py-1 d-flex flex-column gap-2  highlighted-menu">
                  <input
                    value={serviceName}
                    onChange={(e) => {
                      setServiceName(e.target.value);
                      fetchSuggestions(e.target.value);
                    }}
                    className="searchinput fw-bold form-control"
                    placeholder="Search"
                  />
                </div>
                {searchService?.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 100,
                      bottom: searchService?.length < 2 ? -38 
                      : searchService?.length < 4 ? -70 
                      : searchService?.length < 6 ? -130 
                      : -180,
               
                      width: "15%",
                    }}
                    className="suggestions-list mt-1 rounded"
                  >
                    {searchService?.map((service, index) => (
                      <div
                        style={{ color: "black",border:"1px solid black"}}
                        key={index}
                        
                        className="suggestion-item"
                        onClick={() => handleServiceClick(service)}
                      >
                       
                        <h6 className="text-capitalize">
                          {service?.name}
                          <span style={{ fontSize: "14px", fontWeight: 400 }}>
                            {" "}
                            Provided by{" "}
                            {
                              service?.provider_category_detail?.provider
                                ?.first_name
                            }
                          </span>
                        </h6>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {/* Main Menu End */}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
